var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcVisibility = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Visibility")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "oiotyriuoyutroiy",
    x: 0,
    y: 0,
    width: 1170,
    height: 382,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-2.0%",
    width: "102.0%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "oiotyriuoyutr3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "oiotyriuoyutroiy2",
    x: 0,
    y: 0,
    width: 1170,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3.375 C5.25,3.375 2.0475,5.7075 0.75,9 C2.0475,12.2925 5.25,14.625 9,14.625 C12.75,14.625 15.9525,12.2925 17.25,9 C15.9525,5.7075 12.75,3.375 9,3.375 L9,3.375 Z M9,12.75 C6.93,12.75 5.25,11.07 5.25,9 C5.25,6.93 6.93,5.25 9,5.25 C11.07,5.25 12.75,6.93 12.75,9 C12.75,11.07 11.07,12.75 9,12.75 L9,12.75 Z M9,6.75 C7.755,6.75 6.75,7.755 6.75,9 C6.75,10.245 7.755,11.25 9,11.25 C10.245,11.25 11.25,10.245 11.25,9 C11.25,7.755 10.245,6.75 9,6.75 L9,6.75 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "updotaaa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ssssseeeeeeeeqret",
    transform: "translate(-1007.000000, -214.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(250.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sssssmsslll",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oiotyriuoyutroiy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grrustt"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#oiotyriuoyutr3)",
    xlinkHref: "#oiotyriuoyutroiy"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#oiotyriuoyutroiy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "row",
    mask: "url(#sssssmsslll)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oiotyriuoyutroiy2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "grrustt",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#oiotyriuoyutroiy2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.000000, 25.000000)",
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right-copy-2",
    transform: "translate(113.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grrustt"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "vladika",
    className: "color-fill",
    fill: "#3BB33F",
    xlinkHref: "#path-8"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcVisibility, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-visibility.55b0c03d.svg";
export { ForwardRef as ReactComponent };